import { graphql } from "../generated/gql";

export const UpdateNote = graphql(`
  mutation UpdateNote($content: String!, $noteId: ID!) {
    updateNote(content: $content, noteId: $noteId) {
      id
      content
    }
  }
`);
